import { parse, parseISO } from "date-fns";

const defaultFormatString = "yyyy-MM-dd";

export const parseDate = (
  dateString: string,
  formatString: string = defaultFormatString,
): Date => {
  return parse(dateString, formatString, new Date());
};

export const parseDateTime = (
  dateString: string,
  formatString?: string,
): Date => {
  if (formatString) {
    return parseDate(dateString, formatString);
  }
  return parseISO(dateString);
};

export const formatIntlDate =
  (language: string, options?: Intl.DateTimeFormatOptions) => (date: Date) =>
    new Intl.DateTimeFormat(language, {
      day: "2-digit",
      month: "2-digit",
      ...options,
    }).format(date);
